import Screen from '../../../../shared/utils/screen';

function ArrowDownIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={`${46 * Screen.widthRatio}`}
      height={`${27 * Screen.widthRatio}`}
      viewBox={'0 0 46 27'}
    >
      <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g
          transform='translate(-756.000000, -857.000000)'
          fill='#50E3C2'
          stroke='#50E3C2'
          strokeWidth='2'
        >
          <polygon
            id='Arrow-select-item-Copy'
            transform='translate(778.836295, 861.250231) rotate(-135.000000) translate(-778.836295, -861.250231) '
            points='763.836295 875.938914 763.836295 846.561549 793.836295 846.561549 793.836295 849.709124 766.994189 849.709124 766.994189 875.938914'
          ></polygon>
        </g>
      </g>
    </svg>
  );
}

export default ArrowDownIcon;
